<div class="vex-user-menu">
  <a
    (click)="close()"
    [routerLink]="['/user/profile']"
    class="vex-user-menu-item"
    matRipple
    matRippleColor="rgb(var(--color-primary), 0.1)"
  >
    <mat-icon
      class="vex-user-menu-item__icon icon-sm"
      svgIcon="mat:account_circle"
    ></mat-icon>
    <div class="vex-user-menu-item__label">Profil</div>
  </a>

  <div class="mx-4 border-b border-divider"></div>

  <a
    (click)="logout()"
    [routerLink]="['/auth/login']"
    class="vex-user-menu-item"
    matRipple
    matRippleColor="rgb(var(--color-primary), 0.1)"
  >
    <mat-icon
      class="vex-user-menu-item__icon icon-sm"
      svgIcon="mat:logout"
    ></mat-icon>
    <div class="vex-user-menu-item__label">Odhlásit se</div>
  </a>
</div>
